export let queryParams = new URLSearchParams();

export function extractQueryParamsFromHash(): void {
  const hash = window.location.hash;
  const queryIndex = hash.indexOf('?');

  if (queryIndex !== -1) {
    const query = hash.slice(queryIndex + 1);
    queryParams = new URLSearchParams(query);
  } else {
    queryParams = new URLSearchParams();
  }
}

export function extractParamsFromFragment(link: string): Record<string, string> {
  try {
    const parsed = new URL(link);
    const hash = parsed.hash; // includes the '#' prefix

    const queryIndex = hash.indexOf('?');

    if (queryIndex === -1) {
      return {};
    }

    const queryString = hash.slice(queryIndex + 1); // skip '?'
    const params = new URLSearchParams(queryString);

    const result: Record<string, string> = {};

    for (const [key, value] of params.entries()) {
      result[key] = value;
    }

    return result;
  } catch {
    return {};
  }
}
